import railyApiService from "../raily-api.service";
import CompanyLicenseStatusResponse from "./status/company-license-status.response";

const companyLicenseApiService = () => {
  const getCompanyLicenseStatus = async (
    abortSignal: AbortSignal,
  ): Promise<CompanyLicenseStatusResponse> => {
    const url = `/company-licenses/my`;

    return railyApiService(
      process.env.OPTIMIZER_URL,
    ).get<CompanyLicenseStatusResponse>({
      url,
      abortSignal,
    });
  };

  return {
    getCompanyLicenseStatus,
  };
};

export default companyLicenseApiService;
